import { FileActionEnum, MimeTypesEnum } from 'src/app/utils/enums';
import { AccountService } from '../../auth/account.service';
import { BlobToPdfService } from '../../blob-to-pdf.service';
import { FileConvertorService } from '../file-convertor-service';
import { ConversionOptions } from '../models/conversion-options';
import { ConvertorParams } from '../models/convertor-params';
import { ImageToPdfConversionParams } from '../models/image-to-ddf-conversion-params';
import { KesToPdfConversionParams } from '../models/kes-to-pdf-conversion-params';
import { PdfToKesConversionParams } from '../models/pdf-to-kes-conversion-params';

export class BaseConversion {
    protected file: File | null;
    protected url: string;
    protected action: FileActionEnum;
    protected type: MimeTypesEnum;
    protected fileName: string = '';
    protected fileHash: string | null = null;
    protected readingItemIdx: number | null = null;
    protected params: ImageToPdfConversionParams | PdfToKesConversionParams | KesToPdfConversionParams | object = {};
    protected paneIndex: number | null = null;
    protected metadata: any = null;

    constructor(
        protected fileConvertorService: FileConvertorService,
        protected accountService: AccountService,
        protected blobToPdfService: BlobToPdfService
    ) {

    }

    prepareConversionParams(): ConvertorParams | null {
        throw new Error('Not implemented.');
    }

    async setOptions(_options: ConversionOptions): Promise<void> {
        throw new Error('Not implemented.');
    }
}
